import { withInstall } from '../../../../utils/with-install'
import Custom from './Custom.vue'

export const ElAmapLayerCustom = withInstall(Custom)
export default ElAmapLayerCustom
